module.exports = __webpack_public_path__ + "static/media/61.f04248c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/61.png
// module id = 635
// module chunks = 0